import axios from 'axios';

export const createNotebook = async (name, packId) => {
  try {
    const response = await axios.post(`/api/v2/notebooks/`, { name, packId });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getNotebooks = async (packId) => {
  try {
    const response = await axios.get(`/api/v2/notebooks/${packId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getQuestionBookmarkStatus = async (questionId) => {
  try {
    const response = await axios.get(`/api/v1/notebooks/question-status/${questionId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching question bookmark status:', error);
    throw error;
  }
};

export const addQuestionToNotebooks = async (questionId, notebookIds, removedNotebookIds, packId, testId) => {
  try {
    const response = await axios.post(`/api/v1/notebooks/addQuestion`, {
      questionId,
      notebookId: notebookIds,
      removedNotebookId: removedNotebookIds,
      packId,
      testId,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
